var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalAccountIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_710_2989",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31.6404,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_710_2989)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.59259,
    y: -0.585754,
    width: 32.5926,
    height: 32.2264,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_710_2989",
    transform: "matrix(0.015625 0 0 0.0158026 0 -0.00568182)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_710_2989",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAHYAAAB2AH6XKZyAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAABUhJREFUeJztm/trHFUUxz+b5qlBG1NtY6n4gGqjtm5bX1jpoLb4i4o/a19RsL71D1DQ/tIftdUWX0VUFA2iiFCV1heIFCtCVWgakmpa2timYDBRpEnXH85OmJ3c2T337p0ZavKFA7ubued85zt3zj33EZjFzMacvAkA5wNLgCZgEjidL53sEQCliP0GfApsAVYjwvyvEVApQNz+At4F1gAN+VBMFwHVBYjaYeARoCUPomkhQC9AaEeATUAhe7r+EWAvQGjfAt2ZM/aEOUAj9QlQAv4GerKlbo/LgM3ALmA/MIKQD6hfgNB2Ac3Z3I4OFwBPAQdIJh3gT4AS8Blwbvq3Vh2dwFZk+KpFOMCvACXgO3ISoYC8i2H31liAfwFKwG4yLqA6gE9qkDoIvADcDxSBLiQJNpY/LwfWAS8CfTV8aeyNVO84gsXAYAKJMWAbcK2D36XAS8B4gm+NbXK8JzWKwAlD4AlgO3CRhxjzgR3IRMlWgHHgKg8cjFiM+eb7getTiHcTyT2tmn1FChVjRwKZ3cj0Ni10AF8Y4tay9T5JFDAnvPfJJvM2A72G+NXsdzwWST2GAFkPO83Y94SHfASex/Rxvh/3bn9O2VyQ9Bom2QAe1hO2xpxO4Jbw1iBzgtDPD8DtDn5uxm50uM0hxhQ6mV7ebnfwcy8inGnovNvB306DryR728H/FJ6OORvDfpxvAo5VIXgUqQxtsAB9sfSng/8p/Bxzts3Bxw0Kki6v1MsKv6GtijbUJoXLgWtiv73mQFQzS2t38GvDxSXXsJlKFQ+6OAEuRNb9k57OaSTXuOBQFb9R+zjaSNsDbox9/9yR5Eng1Sp/3wmccvSt5eQyMasYskrIlNYVrcA7TH8yb1Hfcvd6g0+TnXGJcyrm5Lo6iIYoAk8CTwDLPPhbgT4RLrRx3IioFnUw3wNh3+hCL8DSsJF2TFwb+z5SB9FLkYpsEdBW/u0fYAj4Epm4uOAEUmFqMBR+iAowF1jpGFyDS5DlrntInp+XgI+QV+Ooh5hfIxWmCsvQd6EFlkRWYLdYOoJ9nlkY8zGJ5fb/IguCRQu/84BhC9+hHUP2FrRYGWt/UtMoWgeET0iDqy2IPYtb0uwCnrG4Pl6pDmoaRQUIE5EG2lzRBGxQXmvCRvSJOs7pgKZRvBL8RRnsTuV13cB5ymtNmIu+t8U57dM0igvwkzLYlUTG0irQvlLVcEZxzXLgithvTuX6avRJSjMdLgB7LHzGbQ+6Je0dsXY/KtpMEYyiGSl7NVPScUT1P2pc1wo8gHRl7bA0CfwKvA78W+PaLmS9ry3y2+PIrpIT3kP/hJyDeMQrVHIaRRZMnbEWvQATTJ8qZ4lVTF8U3VKv0wbkrJ5WhAEkW2eNTgPPYV9cHkUvQAnJuFkeT2kB9hp43OcrQCsyGbER4QOyEaEF+NAQv9d3INMWmKYnpPk6dGJ+8n3UV3AZUUDO4dmKMIBsZfvGLZhz03Fk1ToVdCPn8GxFmESKEx8rR13IUGfaAjuOriKtCw8aAmttHKkVXNb8ioiISQ+gjxSffBxvJpCwsUPIitA6pHaPHpK6GJnNbUD2G/tr+OolhXe+GpqQMwD1ihC3ALtjcsPI8ncuh6Tbge8tyPoUYBR4nnwKrgq0I0NdVgLsBx4jxRu33SoeA+5CsvJGjzxKyJLcYWQlZx8i9BGPMbyjB7chMt4DGjmL/xVmCfAN9Qlw1qOADF9DzFABQrQAD2N3civIg2jaaADuQLbAR5mBAkTRCNwKPIecLh2kcqc5yI1ZGXlUVG3ItDZc0RnNgcMsZlHGf6737lLUjkoqAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAccountIcon);
export default __webpack_public_path__ + "static/media/total_account_icon.c8d05063151c11b3e5e2844d23781499.svg";
export { ForwardRef as ReactComponent };